import { render, staticRenderFns } from "./auto-message-template-search-table.vue?vue&type=template&id=480d595e&scoped=true&"
import script from "./auto-message-template-search-table.vue?vue&type=script&lang=js&"
export * from "./auto-message-template-search-table.vue?vue&type=script&lang=js&"
import style0 from "./auto-message-template-search-table.vue?vue&type=style&index=0&id=480d595e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "480d595e",
  null
  
)

export default component.exports